import './details/details';
import './details/details-cart';
// merged accommodation + package logic, bound per Bootstrap nav tab
import './details/details-booking';
//import './details/details-accommodation';
//import './details/details-fix';
//import './details/details-package';
import './details/details-travel';

$(() => {

    // ALERT BOOKING START
    window.alertBookingTimeout = {};

    window.setAlertBooking = ($target) => {
        const $unit = $target.closest('.unit');
        const unitId = $unit.attr('data-unitid');
        const $alertBooking = $unit.find('.alert-booking');

        $alertBooking.addClass('active');
        const alertTimeout = setTimeout(() => {
            $alertBooking.removeClass('active');
        }, 4000);

        window.alertBookingTimeout[unitId] = alertTimeout;
    }

    $('.alert-booking [data-close]').on('click', e => {
        const $target = $(e.currentTarget);
        const $unit = $target.closest('.unit');
        const unitId = $unit.attr('data-unitid');
        const $alertBooking = $target.closest('.alert-booking');

        $alertBooking.removeClass('active');

        if (window.alertBookingTimeout[unitId]) {
            clearTimeout(window.alertBookingTimeout[unitId]);
            window.alertBookingTimeout[unitId] = 0;
        }
    });
    // ALERT BOOKING END

    // READ MORE START
    const $readMoreContent = $('#description .read-more-content, #price-includes .read-more-content');

    if ($readMoreContent.length) {
        const contentheight = $readMoreContent.height();
        contentheight > 140 && contentheight > 200 && $readMoreContent.addClass('active') && $readMoreContent.siblings('.read-more-open').removeClass('d-none');
    }

    $('.read-more').each((i, elem) => {
        let $content = $(elem).find('.read-more-content');
        let $close = $(elem).find('.read-more-close');
        let $open = $(elem).find('.read-more-open');

        $($open).on('click', function(e) {
            $($content).addClass('no-before expand');
            $(e.currentTarget).addClass('d-none');
            $($close).removeClass('d-none');
        })

        $($close).on('click', function(e) {
            $($content).removeClass('expand');
            $(e.currentTarget).addClass('d-none');
            $($open).removeClass('d-none');

            $('html, body').stop().animate({
                scrollTop: $(elem).offset().top
            }, 0);
            setTimeout(function() {
                $($content).removeClass('no-before');
            }, 500);

        });
    });
    // READ MORE END


    $('.see-on-map').on('click', e => {
        const $target = $(e.currentTarget);
 
        let modalTitle = $target.parent().find('.title-for-modal').text();
        $('#meetPointMap').find('.modal-title').text(modalTitle);
 
        let latLng = $target.attr('data-latlng');
        let $mpMap = $('#meetPointMap').find('.metting-point-map');
        let mapLink = $mpMap.attr('data-src').split('q=')[0];
        mapLink += 'q=' + latLng;
        $mpMap.attr('src', mapLink);
        $mpMap.attr('data-src', mapLink);
 
    });

    // UNIT LINK OPEN MODAL AND TAB
    $('[data-bs-toggle="offcanvas"][data-bs-tab]').on('click', e => {
        const $target = $(e.currentTarget);
        const unitId = $target.attr('data-unitid');
        const $tab = $('#unitModal-' + unitId).find('[id=' + $target.attr('data-bs-tab') + ']');
        $tab.tab('show');
    });
});